module.exports = __webpack_public_path__ + "img/contact-top.e4a7aa19.jpg";